<template>
<div class="chapter">
<div class="inner_page">
<p class="ded">For Walter Zacharius, who took a shot<br/>and<br/>Daniel Zitin, who took another</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?b3dca416